import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {RuteosListComponent} from './ruteos-list.component';
import {RuteosService} from './ruteos.service';
import {Observable} from 'rxjs/Observable';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {IMerchant} from './merchant';
import {IIssuer} from './issuer';
import {IAccountingNature} from './accountingnature';
import {IServiceInstance} from './serviceinstance';
import * as $ from 'jquery';

@Component({
  selector: 'pm-add-ruteo',
  templateUrl: './add-ruteo.component.html',
  styleUrls: ['./add-ruteo.component.sass']
})
export class AddRuteoComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'RUTEO';

  merchantSelected: any;

  merchantList: IMerchant[];
  issuerList: Observable<IIssuer[]> = this.service.getIssuers();
  accountingNatureList: Observable<IAccountingNature[]> = this.service.getAccountingNatures();
  serviceInstanceList: Observable<IServiceInstance[]> = this.service.getServiceInstances();

  constructor(public parent: RuteosListComponent, public service: RuteosService, private router: Router) {
  }

  ngOnInit() {
    this.resetForm();

    this.service.getMerchants().subscribe((merchants) => {
      this.merchantList = merchants;
      this.merchantSelected = merchants[0];
    });
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }

    this.service.formData = {
      id: 0, // 8,
      merchantId: 0, // 117,
      merchantName: '', // Santa Fe I,
      cardIssuerId: '', // 0,
      cardIssuerName: '', // TODOS,
      accountingNature: '', // 0,
      accoutingNatureValue: '', // TODAS,
      serviceInstanceId: '', // 2,
      serviceInstanceName: '', // PROSA
      merchantObj: null
    };
  }

  ngAfterViewInit() {
    $('a[rel=ruteo]').addClass('selected');
  }

  cancelRuteo(): void {
    this.parent.showRuteos = true;
    this.parent.showAddRuteo = false;
  }

  addRuteo(form: NgForm): void {
    console.log('addRuteo: form: ', form.value);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    form.value.cardIssuerId = parseInt(form.value.cardIssuerId);
    // form.value.accountingNature = parseInt(form.value.accountingNature);
    form.value.serviceInstanceId = parseInt(form.value.serviceInstanceId);
    form.value.merchantId = parseInt(this.merchantSelected.id);

    this.parent.showRuteos = true;
    this.parent.showAddRuteo = false;

    this.service.addRuteo(form.value).subscribe(
      res => {
        console.log('AddRuteoComponent: addRuteo: res: ', res);
        this.router.navigate(['/ruteo']);
      },
      err => console.log('AddRuteoComponent: addRuteo: err: ', err)
    );
  }

  ngOnDestroy() {
    $('a[rel=ruteo]').removeClass('selected');
  }
}
